import { makeStyles } from "@material-ui/core";
import React from "react";
import { clsx } from "clsx";

const useStyle = makeStyles((theme) => {
  return {
    root: (props) => ({
      backgroundColor: "rgba(248, 249, 252, 1)",
      padding: theme.spacing(2),
      borderRadius: theme.spacing(2),
      ...props?.styles?.root,
    }),
  };
});

export default function DashboardWidgetCard(props) {
  const classes = useStyle(props);
  return (
    <div className={clsx(classes.root, props.className)}>{props.children}</div>
  );
}
